module.exports = __webpack_public_path__ + "img/5g_model_rood_beck.303f1292.png";